import { render } from "./MaixMessagesDashboard.vue?vue&type=template&id=928d1f14&scoped=true"
import script from "./MaixMessagesDashboard.vue?vue&type=script&lang=js"
export * from "./MaixMessagesDashboard.vue?vue&type=script&lang=js"

import "./MaixMessagesDashboard.vue?vue&type=style&index=0&id=928d1f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928d1f14"]])

export default __exports__